import { jsx as i, jsxs as n } from "react/jsx-runtime";
import { Input as I } from "../Input/Input.js";
import { Select as b } from "../Select/Select.js";
import '../../assets/InputGroup.css';function q({
  label: p,
  name: t,
  helper: r,
  type: a = "text",
  style: l,
  group: e,
  className: s = "",
  inputClassName: u = "",
  onChange: o,
  onGroupChange: c,
  onMouseEnter: d,
  onMouseLeave: m,
  onFocus: h,
  onBlur: G,
  id: v,
  step: N,
  value: f = void 0,
  groupValue: x = "",
  inputRef: C,
  min: j,
  max: y,
  extra: A
}) {
  return /* @__PURE__ */ i("div", { className: `inputGroup ${s}`, style: l, children: /* @__PURE__ */ n("div", { className: "inputGroup-container", children: [
    /* @__PURE__ */ n("div", { className: "inputGroup-element", children: [
      /* @__PURE__ */ i("div", { className: "inputGroup-inputContainer", children: /* @__PURE__ */ i(
        I,
        {
          ref: C,
          id: v,
          name: t,
          label: p,
          onChange: o,
          inputClassName: "inputGroup-input " + u,
          type: a,
          value: f,
          step: N,
          min: j,
          max: y,
          onMouseEnter: d,
          onMouseLeave: m,
          onFocus: h,
          onBlur: G
        }
      ) }),
      /* @__PURE__ */ i("div", { children: Array.isArray(e) ? /* @__PURE__ */ i(
        b,
        {
          label: "",
          id: "",
          onChange: c,
          className: "inputGroup-select",
          value: x,
          options: e
        }
      ) : /* @__PURE__ */ i("div", { className: "inputGroup-unit", children: e }) })
    ] }),
    /* @__PURE__ */ n("div", { className: "inputGroup-helpers", children: [
      /* @__PURE__ */ i("span", { children: r && /* @__PURE__ */ i("small", { className: "inputGroup-helper", children: r }) }),
      A
    ] })
  ] }) });
}
export {
  q as InputGroup
};
//# sourceMappingURL=InputGroup.js.map
